import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: '/tag/list',
    name: 'pages-tags-list',
    component: () => import('@/views/pages/tag/TagList.vue'),
    meta: {
      resource: 'tag',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('tags.mainVerticalMenu.tags'),
    },
  },
  {
    path: '/tag/add',
    name: 'pages-tags-add',
    component: () => import('@/views/pages/tag/TagAdd.vue'),
    meta: {
      resource: 'tag',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('tags.mainVerticalMenu.tags'),
    },
  },
  {
    path: '/tag/edit/:id',
    name: 'pages-tags-edit',
    component: () => import('@/views/pages/tag/TagEdit.vue'),
    meta: {
      resource: 'tag',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('tags.mainVerticalMenu.tags'),
    },
  },
]
